import { Component } from "react";
import {
  getStoreComment,
  createStoreComment,
  updateStoreComment,
  getStore
} from "../../../backend/stores";
import { getStoreMachines } from "../../../backend/machines";
import View from "./view";
import "./index.css";
import { withRouter } from "react-router-dom";

class CommentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      machines: [],
      confirmDialogVisible: false,
      spare_hire_book: undefined,
      uploading: false,
      loading: false,
      reinspectionForm: Boolean(props.match.params.comment_id)
    };

    this._toggleConfirmDialog = this._toggleConfirmDialog.bind(this);
    this._upload = this._upload.bind(this);
    this._navigate = this._navigate.bind(this);
    this._editMachine = this._editMachine.bind(this);
    this._valid = this._valid.bind(this);
  }

  async componentDidMount() {
    if (
      this.props.match.params.store_id &&
      !this.props.match.params.comment_id
    ) {
      const { name, id } = await getStore(this.props.match.params.store_id);
      console.log("mounting without comment");

      this.setState({ loading: true });
      this.setState({
        loading: false,
        store: { label: name, value: id },
        machines: await getStoreMachines(this.props.match.params.store_id)
      });
    } else if (this.props.match.params.comment_id) {
      console.log("mounting with comment");
      this.setState({ loading: true });
      this.setState({
        loading: false,
        store: await getStore(this.props.match.params.store_id),
        ...(await getStoreComment(this.props.match.params.comment_id))
      });
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.match.params.store_id !== this.props.match.params.store_id &&
      this.props.match.params.store_id
    ) {
      console.log("updating same store");

      this.setState({ loading: true });
      this.setState({
        machines: await getStoreMachines(this.props.match.params.store_id),
        loading: false
      });
    } else if (
      prevProps.match.params.comment_id &&
      !this.props.match.params.comment_id
    ) {
      console.log("updating no comment id");

      const { name, id } = await getStore(this.props.match.params.store_id);
      this.setState({
        machines: await getStoreMachines(this.props.match.params.store_id),
        reinspectionForm: false,
        store: { label: name, value: id }
      });
    }
  }

  render() {
    return View.call(this);
  }

  _editMachine(index, inputType = "input", prop) {
    return event => {
      let value;
      if (inputType === "radio") {
        value = event;
      } else if (inputType === "select") {
        value = event.value;
      } else if (inputType === "input") {
        value = event.target.value;
      }

      let { machines } = this.state;
      machines = machines.map((m, i) => {
        if (i === index) {
          return { ...m, [prop]: value };
        } else {
          return m;
        }
      });

      this.setState({ machines });
    };
  }

  async _upload() {
    const {
      machines,
      inspection_note,
      priority,
      require_action,
      reinspectionForm,
      complete,
      added_note
    } = this.state;
    this.setState({ uploading: true });

    if (reinspectionForm) {
      await updateStoreComment({
        store_id: this.props.match.params.store_id,
        group_id: this.props.match.params.comment_id,
        complete,
        added_note
      });
    } else {
      await createStoreComment({
        store_id: this.props.match.params.store_id,
        priority,
        inspection_note,
        machines,
        require_action
      });
    }
    this.setState({ uploading: false });
    this.props.redirect &&
      this._navigate(`/stores/${this.props.match.params.store_id}`)();
  }

  _toggleConfirmDialog() {
    this.setState({ confirmDialogVisible: !this.state.confirmDialogVisible });
  }

  _valid() {
    return true;
    // return this.state.reinspectionForm
    //   ? this.state.added_note !== undefined
    //   : this.state.priority !== undefined &&
    //       this.state.all_equipment_okay !== undefined &&
    //       this.state.inspection_note !== undefined &&
    //       this.state.require_action !== undefined;
  }

  _navigate(location) {
    const { history } = this.props;
    return event => {
      history.push(location);
    };
  }

  _change(prop, ev = false, sel = false) {
    return event =>
      this.setState({
        [prop]: ev ? (sel ? event.value : event) : event.target.value
      });
  }
}

CommentForm.defaultProps = {
  redirect: true
};

export default withRouter(CommentForm);



// WEBPACK FOOTER //
// ./src/screens/stores/comment-form/index.js